import React from 'react';
import { PieChart, CheckCircle2, ArrowRight } from 'lucide-react';
export function InvestorAsk() {
  return <section id="investors" className="py-20 lg:py-32 bg-slate-950 border-t border-slate-900 relative" data-id="element-133">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-emerald-900/10 via-slate-950 to-slate-950 pointer-events-none" data-id="element-134"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-135">
        <div className="text-center mb-16" data-id="element-136">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-137">
            Fueling the Next Stage of Growth
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-138">
            Join us in transforming the energy landscape. We are raising capital
            to validate our technology and scale operations.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-139">
          {/* Main Ask Card */}
          <div className="lg:col-span-5 bg-emerald-900/20 border border-emerald-500/30 rounded-3xl p-8 md:p-10 flex flex-col justify-center relative overflow-hidden" data-id="element-140">
            <div className="absolute -right-10 -top-10 w-40 h-40 bg-emerald-500/20 rounded-full blur-3xl" data-id="element-141"></div>

            <div className="text-emerald-400 font-semibold tracking-wider uppercase text-sm mb-4" data-id="element-142">
              Seed Round
            </div>
            <div className="text-6xl font-extrabold text-white mb-2" data-id="element-143">
              $300,000
            </div>
            <div className="text-slate-300 mb-8" data-id="element-144">Currently Raising</div>

            <div className="space-y-6 mb-8" data-id="element-145">
              <div data-id="element-146">
                <div className="flex justify-between text-sm mb-2" data-id="element-147">
                  <span className="text-white font-medium" data-id="element-148">
                    Stage 1: Validate
                  </span>
                  <span className="text-emerald-400 font-bold" data-id="element-149">$50,000</span>
                </div>
                <p className="text-slate-400 text-sm" data-id="element-150">
                  Finalize system engineering and pilot operations.
                </p>
              </div>

              <div className="border-t border-emerald-500/20 pt-6" data-id="element-151">
                <div className="flex justify-between text-sm mb-2" data-id="element-152">
                  <span className="text-white font-medium" data-id="element-153">Stage 2: Scale</span>
                  <span className="text-emerald-400 font-bold" data-id="element-154">$250,000</span>
                </div>
                <p className="text-slate-400 text-sm" data-id="element-155">
                  Kickstart expansion and secure municipal contracts.
                </p>
              </div>
            </div>

            <a href="mailto:invest@greenfuel.com" className="w-full inline-flex items-center justify-center px-6 py-4 text-base font-bold text-slate-900 bg-emerald-400 rounded-xl hover:bg-emerald-300 transition-colors" data-id="element-156">
              Request Pitch Deck
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-157" />
            </a>
          </div>

          {/* Metrics & Impact */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-158">
            <div className="bg-slate-900 border border-slate-800 rounded-3xl p-8 flex flex-col justify-center" data-id="element-159">
              <PieChart className="w-10 h-10 text-emerald-400 mb-6" data-id="element-160" />
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-161">Key Metrics</h3>
              <div className="text-3xl font-extrabold text-white mb-2" data-id="element-162">
                $40,000
                <span className="text-lg text-slate-500 font-normal" data-id="element-163">/mo</span>
              </div>
              <p className="text-slate-400 text-sm" data-id="element-164">
                Recurring revenue potential from initial pilot deployment.
              </p>
            </div>

            <div className="bg-slate-900 border border-slate-800 rounded-3xl p-8 flex flex-col justify-center" data-id="element-165">
              <h3 className="text-xl font-bold text-white mb-6" data-id="element-166">
                Milestones Unlocked
              </h3>
              <ul className="space-y-4" data-id="element-167">
                <li className="flex items-start gap-3" data-id="element-168">
                  <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-169" />
                  <span className="text-slate-300 text-sm" data-id="element-170">
                    Covers all operating costs
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-171">
                  <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-172" />
                  <span className="text-slate-300 text-sm" data-id="element-173">
                    Validates AI efficiency claims
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-174">
                  <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-175" />
                  <span className="text-slate-300 text-sm" data-id="element-176">
                    Unlocks scalable growth model
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}